<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h2>{{ $t('carriers.carriers') }}</h2>
        <carriers-table-component/>
    </layout-authenticated>
</template>

<script>
import CarriersTableComponent from '@/components/admin/tables/CarriersTableComponent'
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: "Carriers",
    components: {LayoutAuthenticated, CarriersTableComponent},
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.administration'),
                    href: '/admin'
                },
                {
                    text: this.$t('carriers.carriers'),
                    href: '/admin/carriers',
                    disabled: true
                }
            ];
        }
    }
}
</script>
